<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => this.$router.go(-1)"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Plano de Atendimento Educacional Especializado – PAEE
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-title>PLANO DE ATENDIMENTO EDUCACIONAL ESPECIALIZADO – PAEE</v-card-title>
          <v-card-text>
            <h4>
              Aluno(a): {{ matricula && matricula.aluno ? matricula.aluno.nomecompleto : "- - -" }}
            </h4>
            <h4>
              Data de Nascimento:
              {{
                matricula?.aluno?.data_nascimento
                  ? new Date(matricula.aluno.data_nascimento + "T00:00:00").toLocaleDateString(
                      "pt-BR"
                    )
                  : "- - -"
              }}
            </h4>
            <h4>
              Escola:
              {{
                gestao && gestao.turma && gestao.turma.franquia
                  ? gestao.turma.franquia.descricao
                  : "- - -"
              }}
            </h4>
            <h4>
              Etapa:
              {{ matricula?.serie ? matricula?.serie.descricao : "..." }}
            </h4>
            <h4>
              Profissional: {{ gestao && gestao.profissional ? gestao.profissional.name : "- - -" }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12 text-center" class="pt-0 pb-4">
        <v-toolbar flat>
          <v-tabs dark v-model="form.bimestre" background-color="primary" grow>
            <v-tab
              v-for="item of $constants.bimestres"
              :key="item.value"
              @click="() => loadData(item.value)"
            >
              <v-badge v-if="form.bimestre === item.value" color="success" dot overlap>
                {{ item.desc }}
              </v-badge>
              <div v-else>{{ item.desc }}</div>
            </v-tab>
          </v-tabs>
        </v-toolbar>
      </v-col>
    </v-row>

    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(salvar)" :disabled="submittingForm">
        <!-- Seção 1: Identificação -->
        <v-card class="mt-4 mb-4">
          <v-card-title>1. Identificação do Estudante</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" lg="2">
                <ValidationProvider
                  name="CID"
                  :rules="{ max_chars: 10, no_special_chars: true }"
                  v-slot="{ errors }"
                >
                  <e-label>CID</e-label>
                  <v-text-field
                    v-model="form.cid"
                    solo
                    dense
                    :error-messages="errors"
                    counter="10"
                    maxlength="10"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" lg="2">
                <e-label>Idade em que entrou na escola:</e-label>
                <v-text-field
                  :value="idadeEntradaEscola"
                  solo
                  dense
                  readonly
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="6">
                <e-label>Endereço:</e-label>
                <v-text-field :value="enderecoCompleto" solo dense readonly disabled></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Seção 2: Tipo de Deficiência -->
        <v-card class="mb-4 py-2">
          <v-card-title>2. Tipo de Deficiência</v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                v-for="opcao in tiposDeficienciaOpcoes"
                :key="opcao"
                cols="12"
                sm="6"
                md="4"
                class="py-0"
              >
                <v-checkbox
                  v-model="form.tipos_deficiencia"
                  :label="opcao"
                  :value="opcao"
                  dense
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="py-0">
                <v-checkbox
                  v-model="temOutraDeficiencia"
                  label="Outra"
                  dense
                  hide-details
                  @change="onOutraDeficienciaChange"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" v-if="temOutraDeficiencia" class="pt-2">
                <ValidationProvider
                  name="Outra deficiência"
                  :rules="{ required: true, max_chars: 200, no_special_chars: true }"
                  v-slot="{ errors }"
                >
                  <e-label>Especifique a outra deficiência</e-label>
                  <v-text-field
                    v-model="form.outra_deficiencia"
                    solo
                    dense
                    :error-messages="errors"
                    counter="200"
                    maxlength="200"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Seção 3: Profissionais Envolvidos -->
        <v-card class="mb-4 py-2">
          <v-card-title
            >3. Outros Profissionais Envolvidos no Acompanhamento do Estudante</v-card-title
          >
          <v-card-text>
            <v-row
              v-for="prof in form.profissionais_envolvidos"
              :key="prof.tipo"
              align="center"
              class="mb-0"
            >
              <v-col cols="12" sm="3" md="2" class="py-0">
                <v-checkbox
                  v-model="prof.selecionado"
                  :label="prof.tipo"
                  dense
                  hide-details
                  @change="!prof.selecionado ? (prof.nome = '') : null"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="7" md="4" class="py-0" v-if="prof.selecionado">
                <ValidationProvider
                  :name="`Nome do(a) ${prof.tipo}`"
                  :rules="{ max_chars: 150, no_special_chars: true }"
                  v-slot="{ errors }"
                >
                  <e-label>Nome do(a) {{ prof.tipo }}:</e-label>
                  <v-text-field
                    v-model="prof.nome"
                    solo
                    dense
                    :error-messages="errors"
                    counter="150"
                    maxlength="150"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Seção 4: Sala de Recursos -->
        <v-card class="mb-4 py-2">
          <v-card-title>4. Dados da Sala de Recursos Multifuncionais</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <h4>
                  Escola que oferece o AEE:
                  {{
                    gestao && gestao.turma && gestao.turma.franquia
                      ? gestao.turma.franquia.descricao
                      : "- - -"
                  }}
                </h4>
              </v-col>

              <v-col cols="12" md="3">
                <e-label>5 – Frequência Semanal</e-label>
                <v-radio-group v-model="form.frequencia_semanal" dense hide-details>
                  <v-radio label="1 vez por semana" value="1"></v-radio>
                  <v-radio label="2 vezes por semana" value="2"></v-radio>
                  <v-radio label="3 vezes por semana" value="3"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" md="3">
                <e-label>6 – Tempo de Atendimento</e-label>
                <v-radio-group v-model="form.tempo_atendimento" dense hide-details>
                  <v-radio label="1 hora" value="1h"></v-radio>
                  <v-radio label="1h30min" value="1h30min"></v-radio>
                  <v-radio label="2 horas" value="2h"></v-radio>
                  <v-radio label="Outro" value="outro"></v-radio>
                </v-radio-group>
                <ValidationProvider
                  v-if="form.tempo_atendimento === 'outro'"
                  name="Tempo de atendimento (outro)"
                  :rules="{ required: true, max_chars: 50, no_special_chars: true }"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="form.tempo_atendimento_outro"
                    label="Qual?"
                    solo
                    dense
                    class="mt-2"
                    :error-messages="errors"
                    counter="50"
                    maxlength="50"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>

              <v-col cols="12" md="3">
                <e-label>6.1 – Composição do Atendimento</e-label>
                <v-radio-group v-model="form.composicao_atendimento" dense hide-details>
                  <v-radio label="Atendimento Individual" value="Individual"></v-radio>
                  <v-radio label="Atendimento em Grupo" value="Grupo"></v-radio>
                  <v-radio label="Na própria sala de aula" value="Própria Sala de Aula"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="3">
                <e-label class="mt-3">6.2 – Atendimento</e-label>
                <v-radio-group v-model="form.tipo_atendimento" dense hide-details>
                  <v-radio
                    v-for="tipo in ['Presencial', 'Remoto', 'Híbrido']"
                    :key="tipo"
                    :label="tipo"
                    :value="tipo"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Seção 7: Descrição do Caso -->
        <v-card class="mb-4">
          <v-card-title>7. Descrição do Caso</v-card-title>
          <v-card-text>
            <ValidationProvider
              name="Descrição do Caso"
              :rules="{ max_chars: 1500, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <v-textarea
                v-model="form.descricao_caso"
                solo
                rows="5"
                :error-messages="errors"
                counter="1500"
                maxlength="1500"
              ></v-textarea>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <!-- Seção 8: Dados Pedagógicos -->
        <v-card class="mb-4">
          <v-card-title>8. Dados Pedagógicos</v-card-title>
          <v-card-text>
            <ValidationProvider
              name="Objetivo do Plano"
              :rules="{ max_chars: 1500, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>8.1 – Objetivo do Plano</e-label>
              <v-textarea
                v-model="form.objetivo_plano"
                solo
                rows="4"
                class="mb-4"
                :error-messages="errors"
                counter="1500"
                maxlength="1500"
              ></v-textarea>
            </ValidationProvider>

            <e-label class="mb-2">8.2 – Áreas do Desenvolvimento</e-label>
            <v-simple-table class="mb-4" style="border: 1px solid #e0e0e0">
              <thead>
                <tr>
                  <th style="width: 18%; background-color: #e8e8d8">Área</th>
                  <th style="width: 27%; background-color: #e8e8d8">Habilidades</th>
                  <th style="width: 27%; background-color: #e8e8d8">Dificuldades</th>
                  <th style="width: 28%; background-color: #e8e8d8">
                    Atividades a serem desenvolvidas
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="area in form.areas_desenvolvimento" :key="area.area">
                  <td style="font-weight: bold; vertical-align: middle">{{ area.area }}</td>
                  <td>
                    <ValidationProvider
                      :name="`Habilidades (${area.area})`"
                      :rules="{ max_chars: 250, no_special_chars: true }"
                      v-slot="{ errors }"
                    >
                      <v-textarea
                        v-model="area.habilidades"
                        solo
                        dense
                        rows="4"
                        :error-messages="errors"
                        counter="250"
                        maxlength="250"
                        class="py-4"
                        no-resize
                      ></v-textarea>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      :name="`Dificuldades (${area.area})`"
                      :rules="{ max_chars: 250, no_special_chars: true }"
                      v-slot="{ errors }"
                    >
                      <v-textarea
                        v-model="area.dificuldades"
                        solo
                        dense
                        rows="4"
                        :error-messages="errors"
                        counter="250"
                        maxlength="250"
                        class="py-4"
                        no-resize
                      ></v-textarea>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      :name="`Atividades (${area.area})`"
                      :rules="{ max_chars: 250, no_special_chars: true }"
                      v-slot="{ errors }"
                    >
                      <v-textarea
                        v-model="area.atividades"
                        solo
                        dense
                        rows="4"
                        :error-messages="errors"
                        counter="250"
                        maxlength="250"
                        class="py-4"
                        no-resize
                      ></v-textarea>
                    </ValidationProvider>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <ValidationProvider
              name="Avaliação e Acompanhamento"
              :rules="{ max_chars: 1500, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label>8.3 – Avaliação e Acompanhamento</e-label>
              <v-textarea
                v-model="form.avaliacao_acompanhamento"
                solo
                rows="4"
                class="mb-4"
                :error-messages="errors"
                counter="1500"
                maxlength="1500"
              ></v-textarea>
            </ValidationProvider>

            <ValidationProvider
              name="Recursos e Apoios Necessários"
              :rules="{ max_chars: 1500, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label
                >8.4 – Recursos e Apoios Necessários (Seleção de materiais a serem produzidos/
                adquiridos para o aluno)</e-label
              >
              <v-textarea
                v-model="form.recursos_apoios"
                solo
                rows="4"
                class="mb-4"
                :error-messages="errors"
                counter="1500"
                maxlength="1500"
              ></v-textarea>
            </ValidationProvider>

            <ValidationProvider
              name="Profissionais da escola para orientação"
              :rules="{ max_chars: 1500, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <e-label
                >8.5 – Profissionais da escola que receberão orientação do professor de AEE sobre
                serviços oferecidos ao aluno</e-label
              >
              <v-textarea
                v-model="form.profissionais_orientacao"
                solo
                rows="4"
                :error-messages="errors"
                counter="1500"
                maxlength="1500"
              ></v-textarea>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <v-col cols="12" class="mt-2">
          <v-row>
            <v-btn
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              class="mr-3"
              lg
              block
            >
              <v-icon left>mdi-content-save</v-icon>
              Salvar
            </v-btn>
          </v-row>
        </v-col>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
const TIPOS_DEFICIENCIA = [
  "Deficiência Visual",
  "Deficiência Auditiva",
  "Deficiência Intelectual",
  "Transtorno do Espectro do Autismo – TEA",
  "Deficiência Física",
  "Altas Habilidades/Superdotação",
  "Transtorno do déficit de atenção",
  "Transtorno do déficit de atenção e Hiperatividade – TDAH",
];

const PROFISSIONAIS = [
  "Fonoaudiólogo",
  "Psicólogo",
  "Fisioterapeuta",
  "Psicopedagoga",
  "Terapeuta Ocupacional",
  "Área Médica",
  "Outros",
];

const AREAS = [
  "Linguagem",
  "Desenvolvimento Motor",
  "Desenvolvimento Cognitivo",
  "Desenvolvimento Social",
];

function formVazio(bimestre = 0) {
  return {
    bimestre,
    cid: "",
    tipos_deficiencia: [],
    outra_deficiencia: "",
    profissionais_envolvidos: PROFISSIONAIS.map((tipo) => ({
      tipo,
      selecionado: false,
      nome: "",
    })),
    frequencia_semanal: "",
    tempo_atendimento: "",
    tempo_atendimento_outro: "",
    composicao_atendimento: "",
    tipo_atendimento: "",
    descricao_caso: "",
    objetivo_plano: "",
    areas_desenvolvimento: AREAS.map((area) => ({
      area,
      habilidades: "",
      dificuldades: "",
      atividades: "",
    })),
    avaliacao_acompanhamento: "",
    recursos_apoios: "",
    profissionais_orientacao: "",
  };
}

export default {
  data() {
    return {
      submittingForm: false,
      fichaExiste: false,
      gestao: null,
      matricula: null,
      temOutraDeficiencia: false,
      tiposDeficienciaOpcoes: TIPOS_DEFICIENCIA,
      form: formVazio(),
    };
  },
  computed: {
    idadeEntradaEscola() {
      if (
        !this.matricula ||
        !this.matricula.aluno ||
        !this.matricula.aluno.data_nascimento ||
        !this.matricula.created_at
      ) {
        return "- - -";
      }
      const nascimento = new Date(this.matricula.aluno.data_nascimento);
      const entrada = new Date(this.matricula.created_at);
      let anos = entrada.getFullYear() - nascimento.getFullYear();
      const m = entrada.getMonth() - nascimento.getMonth();
      if (m < 0 || (m === 0 && entrada.getDate() < nascimento.getDate())) {
        anos--;
      }
      return `${anos} anos`;
    },
    enderecoCompleto() {
      if (!this.matricula?.aluno) return "- - -";
      const { endereco, numero, bairro } = this.matricula.aluno;

      const partes = [endereco, numero, bairro].filter((v) => v && v !== "null");

      return partes.length ? `${partes.join(", ")}.` : "- - -";
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    onOutraDeficienciaChange(val) {
      if (!val) {
        this.form.outra_deficiencia = "";
      }
    },
    profissionaisParaSalvar() {
      return this.form.profissionais_envolvidos
        .filter((p) => p.selecionado)
        .map(({ tipo, nome }) => ({ tipo, nome }));
    },
    profissionaisDoBackend(lista) {
      const map = {};
      (lista || []).forEach((p) => {
        map[p.tipo] = p.nome;
      });
      return PROFISSIONAIS.map((tipo) => ({
        tipo,
        selecionado: tipo in map,
        nome: map[tipo] || "",
      }));
    },
    async loadData(bimestre = null) {
      this.$loaderService.open("Carregando dados...");
      try {
        const { matricula_id, gestaoDeAulasId } = this.$route.params;
        const b = bimestre !== null ? bimestre : this.form.bimestre;

        const response = await this.$services.educacaoInclusivaService.carregarPAEE(
          matricula_id,
          gestaoDeAulasId,
          b
        );
        this.matricula = response.matricula;
        this.gestao = response.gestao;

        this.form = formVazio(b);
        this.temOutraDeficiencia = false;

        if (response.ficha) {
          this.fichaExiste = true;
          const f = response.ficha;

          this.form.cid = f.cid || "";
          this.form.tipos_deficiencia = f.tipos_deficiencia || [];
          this.form.outra_deficiencia = f.outra_deficiencia || "";
          this.temOutraDeficiencia = !!f.outra_deficiencia;
          this.form.profissionais_envolvidos = this.profissionaisDoBackend(
            f.profissionais_envolvidos
          );
          this.form.frequencia_semanal = f.frequencia_semanal || "";
          this.form.tempo_atendimento = f.tempo_atendimento || "";
          this.form.tempo_atendimento_outro = f.tempo_atendimento_outro || "";
          this.form.composicao_atendimento = f.composicao_atendimento || "";
          this.form.tipo_atendimento = f.tipo_atendimento || "";
          this.form.descricao_caso = f.descricao_caso || "";
          this.form.objetivo_plano = f.objetivo_plano || "";
          this.form.avaliacao_acompanhamento = f.avaliacao_acompanhamento || "";
          this.form.recursos_apoios = f.recursos_apoios || "";
          this.form.profissionais_orientacao = f.profissionais_orientacao || "";

          if (f.areas_desenvolvimento && f.areas_desenvolvimento.length > 0) {
            this.form.areas_desenvolvimento = f.areas_desenvolvimento;
          }
        } else {
          this.fichaExiste = false;
        }

        if (this.$refs.observer) {
          this.$refs.observer.reset();
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async salvar() {
      this.submittingForm = true;
      try {
        const { matricula_id, gestaoDeAulasId } = this.$route.params;
        const payload = {
          ...this.form,
          profissionais_envolvidos: this.profissionaisParaSalvar(),
          matricula_id,
          gestao_id: gestaoDeAulasId,
        };
        await this.$services.educacaoInclusivaService.salvarPAEE(payload);
        this.$toast.success("PAEE salvo com sucesso!");
        this.fichaExiste = true;
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
  },
};
</script>

<style scoped></style>
